import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a973425"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", {
  style: {"margin":"auto 0px"},
  class: "headline-5"
}, "Resource Details", -1))
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption px-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Areas of Care:")
], -1))
const _hoisted_5 = { class: "pb-2" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption px-4 pb-2" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Related Topics:")
], -1))
const _hoisted_7 = { class: "pb-2" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "caption px-4" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "Other Information:")
], -1))
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "headline-5"
}
const _hoisted_11 = { class: "headline-5" }
const _hoisted_12 = {
  key: 0,
  class: "ma-0"
}
const _hoisted_13 = ["href"]
const _hoisted_14 = {
  key: 1,
  class: "ma-0"
}
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 2,
  class: "ma-0"
}
const _hoisted_17 = ["href"]
const _hoisted_18 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_contact_google_map = _resolveComponent("contact-google-map")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_other_articles_box = _resolveComponent("other-articles-box")!
  const _component_upcoming_events_box = _resolveComponent("upcoming-events-box")!
  const _component_sidebar_box = _resolveComponent("sidebar-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_help_button)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "w100" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                size: "12",
                                class: "flex"
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_1
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "pa-4 mt-4 ion-justify-content-center" }, {
                            default: _withCtx(() => [
                              (_ctx.contact)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    size: "4",
                                    "size-xs": "12",
                                    "size-sm": "4",
                                    class: "flex"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.contact.avatar)
                                        ? (_openBlock(), _createBlock(_component_ion_img, {
                                            key: 0,
                                            alt: "avatar",
                                            class: "contact-avatar",
                                            src: 
                  (_ctx.contact.avatar.formats.thumbnail
                    ? _ctx.contact.avatar.formats.thumbnail.url
                    : _ctx.contact.avatar.url)
                ,
                                            style: _normalizeStyle({
                  border:
                    '4px solid rgb(' +
                    _ctx.getColor(_ctx.contact.category ? _ctx.contact.category.name : '') +
                    ')',
                })
                                          }, null, 8, ["src", "style"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_col, {
                                size: "8",
                                "size-xs": "12",
                                "size-sm": "8"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.contact)
                                    ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createElementVNode("strong", null, _toDisplayString(_ctx.contact.name), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.contact.organization), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(_ctx.contact.designation), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (_ctx.contact && _ctx.contact.address)
                                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("a", {
                                                        href: 
                        'https://www.google.com/maps/place/' + _ctx.contact.address
                      ,
                                                        target: "_blank"
                                                      }, _toDisplayString(_ctx.contact.address), 9, _hoisted_2)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.contact && _ctx.contact.phone)
                                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 1 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                    default: _withCtx(() => [
                                                      _createElementVNode("a", {
                                                        href: 'tel:' + _ctx.contact.phone
                                                      }, _toDisplayString(_ctx.contact.phone), 9, _hoisted_3)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (_ctx.contact)
                                            ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                    default: _withCtx(() => [
                                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.practices, (practice) => {
                                                        return (_openBlock(), _createElementBlock("span", {
                                                          key: practice.id + '-rac'
                                                        }, _toDisplayString(practice.name) + "  ", 1))
                                                      }), 128))
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _hoisted_4,
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_ctx.contact)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_5, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.areas, (area) => {
                                          return (_openBlock(), _createBlock(_component_ion_chip, {
                                            color: "dark",
                                            outline: "",
                                            onClick: ($event: any) => (_ctx.$router.push('/home/search?search=' + area.name)),
                                            key: area.id + '-area'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { color: "dark" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(area.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _hoisted_6,
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              (_ctx.contact)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_7, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contact.topics, (topic) => {
                                          return (_openBlock(), _createBlock(_component_ion_chip, {
                                            color: "primary",
                                            outline: "",
                                            onClick: ($event: any) => (_ctx.$router.push('/home/search?search=' + topic.name)),
                                            key: topic.id + '-topic'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_ion_label, { color: "primary" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(topic.name), 1)
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        }), 128))
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _hoisted_8,
                          _createVNode(_component_ion_row, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, {
                                "size-sm": "12",
                                "size-xs": "12",
                                size: "12"
                              }, {
                                default: _withCtx(() => [
                                  (_ctx.contact && _ctx.contact.summary)
                                    ? (_openBlock(), _createElementBlock("pre", {
                                        key: 0,
                                        class: "ma-0 px-4",
                                        innerHTML: _ctx.$marked(_ctx.contact ? _ctx.contact.summary : '')
                                      }, null, 8, _hoisted_9))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "pb-2" }, {
                            default: _withCtx(() => [
                              (_ctx.contact && _ctx.contact.lat && _ctx.contact.lng)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    "size-sm": "12",
                                    "size-xs": "12",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_contact_google_map, {
                                        center: { lat: _ctx.contact.lat, lng: _ctx.contact.lng },
                                        markers: _ctx.getMarkers,
                                        zoom: 15,
                                        height: '300px'
                                      }, null, 8, ["center", "markers"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          (_ctx.getProvider)
                            ? (_openBlock(), _createElementBlock("h5", _hoisted_10, "Provider/Coverage"))
                            : _createCommentVNode("", true),
                          (_ctx.getProvider)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 1,
                                class: "pb-4 pt-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    size: "auto",
                                    "size-xs": "6",
                                    "size-sm": "auto"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_img, {
                                        alt: "provider-image",
                                        src: 
                  (_ctx.getProvider.avatar.formats.thumbnail
                    ? _ctx.getProvider.avatar.formats.thumbnail.url
                    : _ctx.getProvider.avatar.url)
                
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, {
                                    size: "8",
                                    "size-xs": "6",
                                    "size-sm": "8",
                                    class: "pl-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("h5", _hoisted_11, _toDisplayString(_ctx.getProvider.name), 1),
                                      (_ctx.getProvider && _ctx.getProvider.address)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_12, [
                                            _createElementVNode("a", {
                                              href: 
                    'https://www.google.com/maps/place/' + _ctx.getProvider.address
                  ,
                                              target: "_blank"
                                            }, _toDisplayString(_ctx.getProvider.address), 9, _hoisted_13)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.getProvider && _ctx.getProvider.phone)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_14, [
                                            _createElementVNode("a", {
                                              href: 'tel:' + _ctx.getProvider.phone
                                            }, _toDisplayString(_ctx.getProvider.phone), 9, _hoisted_15)
                                          ]))
                                        : _createCommentVNode("", true),
                                      (_ctx.getProvider && _ctx.getProvider.website)
                                        ? (_openBlock(), _createElementBlock("p", _hoisted_16, [
                                            _createElementVNode("a", {
                                              href: _ctx.getProvider.website
                                            }, _toDisplayString(_ctx.getProvider.website), 9, _hoisted_17)
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("p", null, _toDisplayString(_ctx.getProvider.coverage), 1)
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_ion_col, { size: "12" }, {
                                    default: _withCtx(() => [
                                      (_ctx.getProvider && _ctx.getProvider.description)
                                        ? (_openBlock(), _createElementBlock("pre", {
                                            key: 0,
                                            class: "ma-0 px-4",
                                            innerHTML: _ctx.$marked(_ctx.getProvider ? _ctx.getProvider.description : '')
                                          }, null, 8, _hoisted_18))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.innerWidth > 1400)
                    ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_sidebar_box, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_other_articles_box, { title: "Related Articles" }),
                              _createVNode(_component_upcoming_events_box, { class: "mt-2" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}